import { RATES } from '../../data/rates'
import { useLanguage } from '../../i18n/LanguageContext'
import { translations } from '../../i18n/translations'

const summerDiff = (RATES.summer.peak - RATES.summer.offpeak) / 100

function calcSaving(watts: number, hoursPerMonth: number): number {
  return Math.round(watts / 1000 * hoursPerMonth * summerDiff)
}

const tipsData = [
  { key: 'dryer' as const, emoji: '👕', watts: 3000, hours: 12 },
  { key: 'washer' as const, emoji: '🧺', watts: 500, hours: 20 },
  { key: 'dishwasher' as const, emoji: '🍽️', watts: 1800, hours: 15 },
  { key: 'ev' as const, emoji: '🚗', watts: 7000, hours: 30 },
  { key: 'oven' as const, emoji: '🔥', watts: 2700, hours: 8 },
]

const sortedTips = [...tipsData].sort(
  (a, b) => calcSaving(b.watts, b.hours) - calcSaving(a.watts, a.hours),
)

export function SavingsTips() {
  const { lang } = useLanguage()

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-300 leading-relaxed">
        {translations.tips.insight[lang]}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {sortedTips.map((tip) => {
          const saving = calcSaving(tip.watts, tip.hours)
          return (
            <div
              key={tip.key}
              className="flex flex-col items-center gap-1 bg-white/5 rounded-lg p-3 text-center"
            >
              <span className="text-2xl">{tip.emoji}</span>
              <span className="text-xs text-slate-400">
                {translations.appliances[tip.key][lang]}
              </span>
              <span className="text-sm font-semibold text-emerald-400">
                ~{saving} {translations.tips.perMonth[lang]}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export function getMaxTipSaving(): number {
  return Math.max(...tipsData.map((tip) => calcSaving(tip.watts, tip.hours)))
}
